import type { SVGProps } from "react";
// generated from Box.svg — do not edit manually
// prettier-ignore
export default function Box(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 21 7 L 12 2 L 3 7 M 21 7 V 17 L 12 22 L 3 17 V 7 M 21 7 L 12 12 L 3 7" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
